import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  finalPayment,
  FinalPaymentUsingToken,
  GetPaymentToken,
  GetStates,
  postIframedata,
  SameAsPatient,
  GetSavedCards,
  InsertPPLogs,
} from "../../../../api";
import { CreditCardPaymentModel, State } from "../../../../store";
import { ArrowBack, CountertopsOutlined } from "@mui/icons-material";
import {
  ListItem,
  ListItemIcon,
  IconButton,
  ListItemText,
  Typography,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  ThemeProvider,
  createTheme,
  TextField,
  Grid,
  Box,
  FormControl,
  InputLabel,
  NativeSelect,
} from "@mui/material"; //FB 8403
import useStyles from "../../../../css/styles";
import { makeStyles, Theme } from "@material-ui/core";
import useMediaQuery from "@mui/material/useMediaQuery";

// Update log
// FB  6192   02/06/2023  DK  Added screen for making payments
// FB  7100   07/20/2023  GA  Unable to add 4 cvc codes to payment
// FB  7106   07/28/2023  SK  Patient Portal : Billing screen enhancements
// FB  7145   07/28/2023  SK  patient portal: update code to make payment screen using 'use card on file' option.
// FB  7323   09/11/2023  GA  When Payment Comes from the Patient Portal, the Transactions Payment Type Must be Credit Card Patient Portal
// FB  7322   09/15/2023  SK  When Windows to Enter Credit Card is Loading, Display a Loader (Patient Portal and EMR - if needed)
// FB  8159   01/30/2024  SK  Payment API Trigger Bug: Payment Process Initiates without necessary fields being entered
// FB  8403   03/12/2024  KI  PP-In payments screen state is not reflected
// FB  8481   04/04/2024  KI  PP : Validations are not working in account access, payments and update pharmacy screen

const PopUpStyles = makeStyles((theme: Theme) => ({
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "rgba(0,0,30,0.4)",
  },
}));
const theme = createTheme({
  palette: {
    primary: {
      main: "#083A4D",
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        onClick: (e) => e.stopPropagation(),
        BackdropProps: {
          sx: {
            pointerEvents: "none",
          },
        },
      },
    },
  },
});

export default function MakePayment() {
  const matches = useMediaQuery("(min-width:600px)");
  const classes = PopUpStyles();
  const [viewIframe, setViewIframe] = useState(true);
  const [model, setModel] = useState(false);
  const [saveCardModel, setSaveCardModel] = useState(false);
  const JSAlert = require("js-alert");
  const styles = useStyles();
  const [states, setStates] = useState<State[]>();
  type CardProps = {
    T_CC_NAME_N: number;
    PATIENT_N: string;
    PAYMENT_N: string;
    CARD_NAME: string;
    PAYMENT_TOKEN: string;
  };
  const styletwo = {
    container: {
      border: "1px grey",
      paddingLeft: matches == false ? "16px" : "80px",
      paddingTop: "40px",
      paddingBottom: "40px",
    },
  };
  const stylestart = {
    container: {
      border: "1px grey",
      paddingLeft: matches == false ? "0px" : "55px",

      paddingTop: "10px",
      backgroundColor: "#F8F8F8",
    },
  };
  const [CardArray, setCardArray] = useState<Array<CardProps>>([
    {
      T_CC_NAME_N: 0,
      PATIENT_N: "",
      PAYMENT_N: "",
      CARD_NAME: "",
      PAYMENT_TOKEN: "",
    },
  ]);
  const [PaymentUrl, setPaymentUrl] = useState("");
  const [sessionId, setSessionId] = useState("");

  const [paymentToken, setPaymentToken] = useState("");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [card, setCardOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [displayName, setDisplayName] = useState("");

  const [amount, setAmount] = useState("");
  const [emrId, setEmrId] = useState(0);
  const [patientID, setPatientID] = useState("");

  const [paymentButton, setPaymentButton] = useState(true);
  const [patientCC, setPatientCC] = useState({} as CreditCardPaymentModel);
  const [transID, setTransID] = useState();

  const handleSaveCardChange = (e: any) => {
    if (e.target.checked) {
      setPatientCC({ ...patientCC, SAVE_CARD: e.target.checked ? 1 : 0 });

      setSaveCardModel(true);
    } else {
      setSaveCardModel(false);
    }
  };
  const handleInputChange = (e: any) => {
    if (e.target.name == "PaymentAmount") {
      if (e.target.value > 9999.99) {
        return false;
      }
      let match = /(\d{0,4})[^.]*((?:\.\d{0,2})?)/g.exec(
        e.target.value.replace(/[^\d.]/g, "")
      );
      if (
        match != null &&
        e.target.value > 0 &&
        e.target.value != "" &&
        e.target.value <= 9999.99
      ) {
        setPatientCC({ ...patientCC, ["PaymentAmount"]: match[1] + match[2] });
        setPaymentButton(false);
      } else {
        setPatientCC({ ...patientCC, ["PaymentAmount"]: e.target.value });
        setPaymentButton(true);
      }
    } else {
      setPatientCC({ ...patientCC, [e.target.name]: e.target.value });
    }
  };

  const handleNextOpen = (e: any) => {
    if (checked == true) {
      setOpen(true);
    }
  };

  function validation() {
    const re = /^[0-9]{5}\-[0-9]{4}$/;
    const rea = /^[0-9]{5}$/;
    const reb = /^[0-9]{9}$/;
    const reexp = /^[a-zA-Z\s]*$/;
    const remonth = /^(0[1-9]|1[012])$/;
    const reyear = /^(?!00)[0-9]{2}$/;

    //FB 8403 updated the alert message
    if (remonth.test(patientCC.month) == false) {
      JSAlert.alert(
        "Please enter valid 2 digits for month.",
        null,
        JSAlert.Icons.Warning
      );
    } else if (reyear.test(patientCC.year) == false) {
      JSAlert.alert(
        "Please enter 2 digits for year",
        null,
        JSAlert.Icons.Warning
      );
    }//FB 7100 GA Start- changed the else if condition and also the alert message, FB 8403 included the undefined condition
     else if (patientCC.CNP == "null" || patientCC.CNP?.length <3 || patientCC.CNP?.length>4 || patientCC.CNP == undefined) {
      JSAlert.alert(
        "Please enter 3-4 digits CVC number.",
        null,
        JSAlert.Icons.Warning
      );
    } //FB 7100 GA End
    else if (
      patientCC.firstNameOnCard == null ||
      patientCC.firstNameOnCard == undefined ||
      patientCC.firstNameOnCard == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid First Name.",
        null,
        JSAlert.Icons.Warning
      );
    } 
    // FB 8159 - Begin
    else if (
      patientCC.address == null ||
      patientCC.address == undefined ||
      patientCC.address == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid Address.",
        null,
        JSAlert.Icons.Warning
      );
    } 
    else if (
      patientCC.city == null ||
      patientCC.city == undefined ||
      patientCC.city == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid City.",
        null,
        JSAlert.Icons.Warning
      );
    }//FB 8403 included state==0 condition
    else if (
      patientCC.state == null ||
      patientCC.state == undefined ||
      patientCC.state == "" ||
      patientCC.state == "0"
    ) {
      JSAlert.alert(
        "Please Choose State.",
        null,
        JSAlert.Icons.Warning
      );
    } 
    
    else if (
      patientCC.phone == null ||
      patientCC.phone == undefined ||
      patientCC.phone == "" ||
      patientCC.phone.length == 0 ||
      patientCC.phone.length < 10
    ) {
      JSAlert.alert(
        "Please Enter Valid Cell Phone Number (must contain 10 numerics).",
        null,
        JSAlert.Icons.Warning
      );
    }
    // FB 8159 - End
     else {
      let isValidZip = re.test(patientCC.zip)
        ? true
        : reb.test(patientCC.zip)
        ? true
        : rea.test(patientCC.zip)
        ? true
        : false;
      if (isValidZip === false) {
        JSAlert.alert(
          "Zip code must be 5 or 9 digits or xxxxx-yyyyy",
          null,
          JSAlert.Icons.Warning
        );
      } else {
        setOpen(true);
      }
    }
  }
  const handleClickOpen = (e: any) => {
    if (saveCardModel == true) {
      if (
        patientCC.CARD_NAME == null ||
        patientCC.CARD_NAME == undefined ||
        patientCC.CARD_NAME == ""
      ) {
        JSAlert.alert("Please enter Card Name", null, JSAlert.Icons.Warning);
      } else validation();
    } else validation();
  };
  const handleUseCardOpen = (event: ChangeEvent<HTMLInputElement>) => {
    setCardOpen(true);
    setChecked(event.target.checked);
    setViewIframe(false);
  };
  const handleClose = () => {
	setValue(""); //FB 8481
    setOpen(false);
    setCardOpen(false);
    setChecked(false);
    setViewIframe(true);
    setIframe({
      index: iframe.index + 1,
    });
    setPaymentUrl("");
    setIsDisabled(true);
    setSessionId("");
    setPaymentToken("");
    handleIframeDetails();
  };
  const [isDisabled, setIsDisabled] = useState(true);
  const [popUpNext, setPopUpNext] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const handlePayment = async (event: any) => {
    setShowSpinner(true);
    const re = /^[0-9]\d{0,3}(?:\.\d{1,2})?$/g;
    if (checked == true) {
      setCardOpen(false);
      if (re.test(patientCC.PaymentAmount) == true) {
        setOpen(false);
        let result = await FinalPaymentUsingToken(
          patientCC.PaymentToken,
          patientCC.PaymentAmount,
          0, // FB 7145
          EMRID // FB 7145
        );
        if (
          (result.PmtResult.CalliPayTransactionID != null ||
            result.PmtResult.CalliPayTransactionID != "") &&
          result.PmtResult.Status == 1
        ) {
          setTransID(result.PmtResult.CalliPayTransactionID);
          setOpenAlert(true);
          InsertPPLogs(
            "Payment Successful - Make Payment Page",
            window.location.href,
            userName,
            ""
          );
        } else if (
          result.PmtResult.ErrorMessage != "" ||
          result.PmtResult.ErrorMessage != null
        ) {
          JSAlert.alert(result.ErrorMessage, null, JSAlert.Icons.Failed);
          navigate("/user/home/Billing");
        }
      } else {
        JSAlert.alert(
          "Please Enter Valid Details",
          null,
          JSAlert.Icons.Warning
        );
        navigate("/user/home/Billing");
        // alert("Please Enter Valid Details");
      }
    } else {
      if (re.test(patientCC.PaymentAmount) == true) {
        setOpen(false);
        patientCC.PaymentToken = paymentToken;
        patientCC.ExpirationDate = patientCC.month + patientCC.year;
        patientCC.Patient_N = emrId;
        patientCC.IS_PORTAL_PAYMENT = 1;// FB 7323 
        let result = await finalPayment(patientCC);
        if (
          (result.PmtResult.CalliPayTransactionID != null ||
            result.PmtResult.CalliPayTransactionID != "") &&
          result.PmtResult.Status == 1
        ) {
          setTransID(result.PmtResult.CalliPayTransactionID);
          setOpenAlert(true);
          InsertPPLogs(
            "Payment Successful - Make Payment Page",
            window.location.href,
            userName,
            ""
          );
        } else if (
          result.PmtResult.ErrorMessage != "" ||
          result.PmtResult.ErrorMessage != null
        ) {
          JSAlert.alert(
            result.PmtResult.ErrorMessage,
            null,
            JSAlert.Icons.Failed
          );
          navigate("/user/home/Billing");
        }
      } else {
        JSAlert.alert(
          "Please Enter Valid Details",
          null,
          JSAlert.Icons.Warning
        );
        navigate("/user/home/Billing");
      }
    }
    setShowSpinner(false);
  };
  let patientName = "User";
  let userName: any;
  let EMRID:any;//FB 7145
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
    EMRID = JSON.parse(data).EMRID;//FB 7145
  }
  async function handleIframeDetails() {
    setShowSpinner(true);
    var data = await postIframedata();
    if (data != null) {
      setPaymentUrl(data.PaymentURL);
      setSessionId(data.SessionID);
      // FB 7322 - Added 5 sec delay - Begin
      setTimeout(() => {
        setShowSpinner(false);
      }, 5000);
      //FB 7322 - End
    } else {
      window.location.reload();
    }
    //FB 7106 - Begin
    let valueFromSessionStorage = sessionStorage.getItem("PayingAmount");
    if(valueFromSessionStorage){
      let numberValue = parseFloat(valueFromSessionStorage);
      setPatientCC({ ...patientCC, ["PaymentAmount"]: numberValue});
      setPaymentButton(false);
    }
    let totalFromSessionStorage = sessionStorage.getItem("Total");
    if(totalFromSessionStorage){
      setTotal(totalFromSessionStorage);
    }
    //FB 7106 - End
  }

  async function getDetails() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        setEmrId(user.EMRID);
        setPatientID(user.Patient_n);
      }
    }
  }

  const [iframe, setIframe] = useState({ index: 0 });

  async function handleChangeCard() {
    setIframe({
      index: iframe.index + 1,
    });
    setPaymentUrl("");

    // var iframe: any = document.getElementById("iframe");
    // iframe.src = iframe.src;

    setIsDisabled(true);
    setSessionId("");
    setPaymentToken("");
    handleIframeDetails();
  }

  const handleRadioChange = async (event: any) => {
    setPopUpNext(false);
    var dataEMR = sessionStorage.getItem("user");
    if (dataEMR != null) {
      const user = JSON.parse(dataEMR);
      if (user.Patient_n != null) {
        var data = await GetSavedCards(user.EMRID);
        if (data != null) {
          var paymentTokenCard = "";
          if (data !== "null") {
            let token = CardArray?.find(
              (state: CardProps) => state.CARD_NAME == event.target.value
            );
            if (token != null || token != undefined) {
              paymentTokenCard = token.PAYMENT_TOKEN;
              setValue(event.target.value);

              setPatientCC((patientCC) => ({
                ...patientCC,
                PaymentToken: paymentTokenCard,
              }));
            }
          }
        }
      }
    }
  };

  const handleChange = async (event: { target: { checked: any } }) => {
    if (event.target.checked) {
      const data = await SameAsPatient(patientID);
      if (data != null) {
        var patientStateName = "";
        if (data.stateID != 0) {
          let patientState = states?.find(
            (state: State) => state.StateID == data.stateID
          );
          if (patientState != null || patientState != undefined) {
            patientStateName = patientState.StateShortName;
          }
        }
        // FB 8159
        setPatientCC({
          ...patientCC,
          firstNameOnCard: data.patientFirstName,
          lastNameOnCard: data.patientLastName,
          address: data.patientPrimaryAddress,
          address2: data.patientSecondAddress,
          city: data.patientCity,
          state: patientStateName,
          zip: data.patientZIP,
          phone: data.patientCellPhone,
          email: data.patientEmail,
          month: patientCC.month,
          year: patientCC.year,
          CNP: patientCC.CNP,
        });
      }
    } 
    // FB 8159
    else {
      setPatientCC({
        ...patientCC,
        firstNameOnCard: "",
        lastNameOnCard: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        email: "",
      });
    }
  };

  async function getDisplayName() {
    var x = sessionStorage.getItem("user");
    if (x != null) {
      const user = JSON.parse(x);
      if (user.Patient_n != null) {
        const data = await SameAsPatient(user.Patient_n);
        setDisplayName(data.patientFirstName);
      }
    }
  }

  async function getStates() {
    var data = await GetStates();
    setStates(data);
  }

  async function getCardname() {
    var dataEMR = sessionStorage.getItem("user");
    if (dataEMR != null) {
      const user = JSON.parse(dataEMR);
      if (user.Patient_n != null) {
        var data = await GetSavedCards(user.EMRID);

        setCardArray(data);
        if (data.length > 0) {
          setModel(true);
        }
      }
    }
  }

  useEffect(() => {
    handleIframeDetails();
    getStates();
    getDisplayName();
    getDetails();
    getCardname();
  }, []);
  const Redirect = () => {
    window.location.reload();
  };
  const [ReloadPopUp, setReloadPopup] = useState(false);

  async function iframeVerification() {
    if (paymentToken == "") {
      if (sessionId != "") {
        if (paymentToken == "") {
          var data = await GetPaymentToken(sessionId);
          if (data != null) {
            setPaymentToken(data);
            setIsDisabled(false);
          }
        }
      }
    }
  }

  const [value, setValue] = useState("");
  const [total, setTotal] = useState("");//FB 7106

  const [openAlert, setOpenAlert] = useState(false);
  const handleCloseAlert = () => {
    setOpenAlert(false);
    navigate("/user/home/Billing");
  };

  function printreceipt() {
    setOpenAlert(false);
    let transaction = { transID: transID, amount: patientCC.PaymentAmount };
    sessionStorage.setItem(
      "Transaction",
      JSON.stringify({ transID: transID, amount: patientCC.PaymentAmount })
    );
    window.open("/payment/printReceipt");
    navigate("/user/home/Billing");
    InsertPPLogs(
      "Clicked on Print Receipt",
      window.location.href,
      userName,
      ""
    );
  }

  return (
    <div>
      <div className="card" style={stylestart.container}>
        <ListItem>
          <ListItemIcon>
            <IconButton onClick={() => navigate("/user/home/Billing")}>
              <ArrowBack />
            </IconButton>
          </ListItemIcon>
          <ListItemText>
            <Typography variant="h5">
              <b>Make Payment</b>
            </Typography>
          </ListItemText>
        </ListItem>
      </div>
      <div className="card" style={styletwo.container}>
        <div className="row">
          <div className="col-sm-4">
            <a style={{ textAlign: "left" }}>
              Enter Credit Card Details
              <br />
              {viewIframe && (
                <iframe
                  src={PaymentUrl}
                  key={iframe.index}
                  style={{ height: "70px" }}
                  id="iframe"
                  onLoad={iframeVerification}
                />
              )}
            </a>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "left" }}>
          <a
            className="btn"
            style={{ backgroundColor: "#13607C", color: "white" }}
            onClick={handleChangeCard}
          >
            Change Card Number
          </a>
          <br />
        </div>
        <div className="row">
          <div className="col-sm-2">
            <br />
            <p style={{ textAlign: "left" }}>
              <Checkbox
                name="SAVE_CARD"
                style={{ width: "20px", height: "30px" }}
                onChange={handleSaveCardChange}
              />{" "}
              Save Card Details
              {matches && <br />}
            </p>
          </div>
          <div
            className="col-sm-4"
            style={{ paddingBottom: matches == false ? "20px" : "0px" }}
          >
            {matches && <br />}
            {saveCardModel && (
              <TextField
                name="CARD_NAME"
                disabled={isDisabled}
                placeholder="Card Name*"
                onChange={handleInputChange}
                value={patientCC.CARD_NAME}
                label="CARD_NAME"
                id="outlined-size-small"
                size="small"
                style={{
                  backgroundColor: isDisabled == false ? "none" : "lightgrey",
                }}
              />
            )}
          </div>
        </div>

        {model && (
          <div className="row">
            <div className="col-sm-2">
              <p style={{ textAlign: "left" }}>
                <Checkbox
                  style={{ width: "20px", height: "30px" }}
                  checked={checked}
                  onChange={handleUseCardOpen}
                />{" "}
                Use Card on file <br />
              </p>
            </div>
          </div>
        )}
        <Dialog open={card} onClose={handleClose}>
          <DialogTitle>Choose Card</DialogTitle>
          <DialogContent style={{ width: "400px", minHeight: "100px" }}>
            <RadioGroup value={value} onChange={handleRadioChange}>
              {CardArray.map((x: CardProps) => (
                <FormControlLabel
                  value={x.CARD_NAME}
                  control={<Radio />}
                  label={x.CARD_NAME}
                  id={x.CARD_NAME}
                />
              ))}
            </RadioGroup>
            <br />
            <button
              className="btn"
              style={{
                backgroundColor: "#13607C",
                color: "white",
                marginTop: "10px",
                marginLeft: "100px",
              }}
              onClick={handleNextOpen}
              disabled={popUpNext}
            >
              Next
            </button>
            &nbsp;
            <button
              className="btn"
              style={button.container}
              onClick={handleClose}
            >
              Cancel
            </button>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
        <div className="row">
          <div className="col-sm-3">
            <p style={{ textAlign: "left" }}>
              *Expiration Date{" "}
              <input
                type="text"
                style={text.container}
                maxLength={2}
                disabled={isDisabled}
                size={2}
                name="month"
                placeholder="MM"
                value={patientCC.month}
                onChange={handleInputChange}
              ></input>
              &nbsp;
              <input
                type="text"
                style={text.container}
                maxLength={2}
                disabled={isDisabled}
                size={2}
                name="year"
                placeholder="YY"
                value={patientCC.year}
                onChange={handleInputChange}
              ></input>
            </p>
          </div>

          <div className="col-sm-4">
            <p style={{ textAlign: "left" }}>
              *CVC{" "}
              <input
                type="text"
                name="CNP"
                style={text.container}
                size={20}
                // FB-7100 changed maxLegnth to 4
                maxLength={4}
                disabled={isDisabled}
                value={patientCC.CNP}
                onChange={handleInputChange}
              ></input>
            </p>
          </div>
        </div>
        <div className="col-sm-4">
          <p style={{ textAlign: "left" }}>
            <Checkbox
              style={{ width: "20px", height: "30px" }}
              onChange={handleChange}
              disabled={isDisabled}
            />{" "}
            Same As Patient <br />
          </p>
        </div>
        <Grid container spacing={2} style={{ paddingBottom: "20px" }}>
          <Grid item xs={6}>
            <TextField
              label="*First Name"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="firstNameOnCard"
              value={patientCC.firstNameOnCard}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Last Name"
              name="lastNameOnCard"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              value={patientCC.lastNameOnCard}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            {/* FB 8159 */}
            <TextField
              label="*Address"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="address"
              value={patientCC.address}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Address2"
              name="address2"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              InputLabelProps={{ shrink: true }}
              value={patientCC.address2}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>

          <Grid item xs={6}>
            {/* FB 8159 */}
            <TextField
              label="*City"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="city"
              value={patientCC.city}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
              size="small"
            >
              {/* FB 8159 */}
              {/* FB 8403 start */}
              <InputLabel id="demo-simple-select-label">*State</InputLabel>
              <NativeSelect 
                id="demo-simple-select-label"
                name="state"
                value={patientCC.state}
                onChange={handleInputChange}
                disabled={isDisabled}
              >
                <option value={0}></option>
                {states?.map((state: State) => (
                  <option value={state.StateShortName}>
                    {state.StateShortName}
                  </option>
                ))}
              </NativeSelect>
              {/* FB 8403 end */}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="*Zip Code"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="zip"
              InputLabelProps={{ shrink: true }}
              value={patientCC.zip}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Email"
              name="email"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              InputLabelProps={{ shrink: true }}
              value={patientCC.email}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            {/* FB 8159- Begin*/}
            <TextField
              label="*CellPhone"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="phone"
              value={patientCC.phone}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
            {/* FB 8159 - End */}
          </Grid>
        </Grid>
        {/* Delete Commented Part of Code */}{/* FB 8159 */}
        <Box style={{ paddingLeft: matches == false ? "30%" : "45%" }}>
          <button
            className="btn"
            style={{
              backgroundColor: "#13607C",
              color: "white",
            }}
            onClick={handleClickOpen}
            disabled={isDisabled}
          >
            Next
          </button>
          &nbsp;
          <button
            className="btn"
            style={{
              color: "#13607C",
              backgroundColor: "#F5F5F7",

              borderColor: "#13607C",
            }}
            onClick={() => navigate("/user/home/Billing")}
          >
            Cancel
          </button>
        </Box>

        {/* <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="btn"
            style={{ backgroundColor: "#13607C", color: "white" }}
            onClick={handleClickOpen}
            disabled={isDisabled}
          >
            Next
          </button>
          &nbsp;
          <button
            className="btn"
            style={{
              color: "#13607C",
              backgroundColor: "#F5F5F7",
              marginRight: "165px",
              borderColor: "#13607C",
            }}
            onClick={() => navigate("/user/home/Billing")}
          >
            Cancel
          </button>
        </div> */}
      </div>
      <div className="col-sm-12">
        <Dialog open={open} onClose={handleClose}>
          <DialogContent>
            {/* FB 7106 */}
            <label>Total Balance :&nbsp;${total}</label>
            <hr></hr>
            <label>Enter Payment Amount</label>
            <br></br>
            {/* <h5>
              * Payment Amount
              {!matches && <br></br>} */}
            {/* <input
                type="text"
                name="PaymentAmount"
                maxLength={7}
                onChange={handleInputChange}
                value={patientCC.PaymentAmount}
                autoComplete="off"
              ></input> */}
            <TextField
              label="*Payment Amount" 
              name="PaymentAmount"
              id="outlined-size-small"
              size="small"
              fullWidth
              style={{ marginTop: "20px" }}
              onChange={handleInputChange}
              value={patientCC.PaymentAmount}
              autoComplete="off"
            />
            {/* <br />{" "}
            </h5> */}
            {matches && <br></br>}
            <button
              className="btn"
              style={{
                backgroundColor: "#13607C",
                color: "white",
                marginTop: "10px",
                marginLeft: "15%",
                width: "75px",
              }}
              onClick={handlePayment}
              disabled={paymentButton}
            >
              Pay
            </button>
            &nbsp;&nbsp;&nbsp;
            <button
              className="btn"
              style={button.container}
              onClick={handleClose}
            >
              Cancel
            </button>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>

      <Dialog
        open={ReloadPopUp}
        style={{
          backdropFilter: "blur(3px)",
        }}
        onClose={Redirect}
      >
        <DialogContent style={{ height: "auto" }}>
          <h5 style={{ textAlign: "center" }}>
            Please refresh this page to make payment!
          </h5>
          <br></br>
          <Box textAlign="center">
            <Button
              variant="contained"
              style={{
                backgroundColor: "#13607C",
                color: "white",
              }}
              onClick={Redirect}
            >
              Ok
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle id="alert-dialog-title">{"Payment"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ color: "black" }}
          >
            Payment Successful!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={printreceipt}
            autoFocus
          >
            Print Receipt
          </Button>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleCloseAlert}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <ThemeProvider theme={theme}>
        <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
          <DialogContent
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress style={{ color: "#083A4D" }} />
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </div>
  );
}

const button = {
  container: {
    marginTop: "10px",
    width: "75px",
    color: "#13607C",
    backgroundColor: "#F5F5F7",
    borderColor: "#13607C",
  },
};

const text = {
  container: {
    height: "35px",
  },
};

const select1 = {
  container: {
    height: "35px",
    width: "595px",
    borderRadius: "1px",
  },
};

const cards = {
  container: {},
};
